export default "__VITE_ASSET__7d7d2ebb__"